import React from 'react';
import { Redirect } from 'react-router-dom';
import { getToken } from 'contexts/AuthContext';

function AuthGuard(props: any) {
  const { children } = props;
  const token = getToken();
  if (token) return <Redirect to="/" />;

  return children;
}

export default AuthGuard;
